import { fetcher } from '@commenda/utils';

export const retireBillingCountryPack = async (packId: string) => {
  const response = await fetcher(`commenda-billing/catalog/packs/${packId}/retire`, {
    method: 'POST',
  });

  return response;
};
